/** Controles de zoom (abajo a la derecha) y deshacer/rehacer (abajo a la izquierda). */
import type { App } from '../app.ts'
import { closePopover, h, openPopoverAt, toolButton } from './dom.ts'
import { icon } from './icons.ts'

export class ZoomBar {
  readonly el: HTMLElement
  private label: HTMLButtonElement
  private app: App

  constructor(app: App) {
    this.app = app
    this.label = h(
      'button',
      { class: 'zoom-level', title: 'Nivel de zoom', onclick: (e: Event) => this.openMenu(e as MouseEvent) },
      ['100 %'],
    ) as HTMLButtonElement

    this.el = h('div', { class: 'zoombar surface' }, [
      toolButton({ icon: icon('minus'), title: 'Alejar (Alt+-)', onClick: () => app.zoomBy(1 / 1.2) }),
      this.label,
      toolButton({ icon: icon('plus'), title: 'Acercar (Alt++)', onClick: () => app.zoomBy(1.2) }),
      toolButton({ icon: icon('fit'), title: 'Ajustar a la pantalla', onClick: () => app.zoomToFit() }),
    ])
    app.store.subscribe(() => this.sync())
    this.sync()
  }

  sync(): void {
    this.label.textContent = `${Math.round(this.app.store.camera.z * 100)} %`
  }

  private openMenu(e: MouseEvent): void {
    const anchor = e.currentTarget as HTMLElement
    const menu = h('div', { class: 'menu-list' }, [
      row('Acercar', 'Alt +', () => this.app.zoomBy(1.2)),
      row('Alejar', 'Alt −', () => this.app.zoomBy(1 / 1.2)),
      h('div', { class: 'menu-sep' }),
      row('Ajustar a la pantalla', '', () => this.app.zoomToFit()),
      row('Centrar en la selección', '', () => this.app.zoomToSelection()),
      h('div', { class: 'menu-sep' }),
      row('50 %', '', () => this.app.zoomTo(0.5)),
      row('100 %', '', () => this.app.zoomTo(1)),
      row('200 %', '', () => this.app.zoomTo(2)),
    ])
    openPopoverAt(menu, { anchor, placement: 'top', align: 'end' })
  }
}

export class UndoBar {
  readonly el: HTMLElement
  private undoBtn: HTMLButtonElement
  private redoBtn: HTMLButtonElement
  private app: App

  constructor(app: App) {
    this.app = app
    this.undoBtn = toolButton({ icon: icon('undo'), title: 'Deshacer (Ctrl+Z)', onClick: () => app.undo() })
    this.redoBtn = toolButton({ icon: icon('redo'), title: 'Rehacer (Ctrl+Y)', onClick: () => app.redo() })
    this.el = h('div', { class: 'undo-bar surface' }, [this.undoBtn, this.redoBtn])
    app.board.undoManager.on('stack-item-added', () => this.sync())
    app.board.undoManager.on('stack-item-popped', () => this.sync())
    app.board.onChange(() => this.sync())
    this.sync()
  }

  sync(): void {
    this.undoBtn.disabled = !this.app.board.canUndo()
    this.redoBtn.disabled = !this.app.board.canRedo()
  }
}

function row(label: string, shortcut: string, onClick: () => void): HTMLElement {
  return h(
    'button',
    {
      class: 'menu-item',
      onclick: () => {
        closePopover()
        onClick()
      },
    },
    shortcut ? [label, h('span', { class: 'shortcut' }, [shortcut])] : [label],
  )
}
